<app-page-heading [key]="'user-dashboard.subcontractors.list.page-title'"></app-page-heading>

<section class="container-fluid summary-panel">
    <div class="row">
        <div class="col-xs-12">
            <select id="carrier-select" class="form-control input-lg" [(ngModel)]="selectedCarrier" *ngIf="!selfCarrierMode"
                    (change)="goToSubcontractors(selectedCarrier.id)">
                <option *ngFor="let carrier of carriers" [ngValue]="carrier">{{carrier.name}}</option>
            </select>
        </div>
    </div>

    <div class="m-t-sm">
        <app-data-table
            [loadObservable]="loadingSubject.asObservable()"
            [columns]="columns"
                        [loadPage]="loadPage"
                        [(filters)]="filters"
                        [filtersComponent]="dataFilters"
                        (onReset)="resetFilters()"
                        (onLoad)="pageLoaded($event)"
                        [noOverflow]="true">

            <app-data-filters #dataFilters>
                <app-data-filter-group>
                    <app-data-filter-input [labelKey]="'user-dashboard.subcontractors.list.filters.name.label'"
                                           [(model)]="filters.name"></app-data-filter-input>
                </app-data-filter-group>
            </app-data-filters>

            <app-data-buttons>
                <button class="btn btn-primary btn-lg pull-right m-l-sm" [disabled]="selectedCarrier && selectedCarrier.blocked"
                        (click)="goToCreateSubcontractor()">
                    <span class="fa fa-plus"></span>
                    <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.list.buttons.create-subcontractor'}]"></span>
                </button>
            </app-data-buttons>
        </app-data-table>
    </div>
</section>


<ng-template #nameColumn let-name="name">
    {{ name }}
</ng-template>

<ng-template #vatCodeColumn let-vatCode="vatCode">
    {{ vatCode }}
</ng-template>

<ng-template #loadGroupColumn let-loadGroup="loadGroup">
    {{ loadGroup }}
</ng-template>


<ng-template #blujayCredentialsColumn let-subcontractor="item">
    <ng-container *ngIf="subcontractor.blujayCredentials.username">
        <a *ngIf="!subcontractor.showBlujayCredentials" (click)="showBlujayCredentials(subcontractor)">
            <i class="fa fa-eye"></i>
            Show Blujay credentials
        </a>
        <span *ngIf="subcontractor.showBlujayCredentials">
                                            <code>{{ subcontractor.blujayCredentials.username }}</code>
                                            <i class="fa fa-arrow-right"></i>
                                            <code>{{ subcontractor.blujayCredentials.apiToken }}</code>
                                        </span>
    </ng-container>
    <span *ngIf="!subcontractor.blujayCredentials.username" class="blujay-credentials-inherited">
                                        <em [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.list.table.blujay-credentials-inherited'}]"></em>
                                    </span>
</ng-template>

<ng-template #actionsColumn let-subcontractor="item" >
    <button class="btn btn-primary" (click)="goToCreateDriver(subcontractor)" [disabled]="selectedCarrier && selectedCarrier.blocked">
        <i class="fa fa-plus"></i>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.list.table.buttons.create-driver'}]"></span>
    </button>
    <button class="btn btn-info" (click)="goToViewDrivers(subcontractor)">
        <i class="fa fa-eye"></i>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.list.table.buttons.view-drivers'}]"></span>
    </button>
    <button class="btn btn-defaut" (click)="goToEditSubcontractor(subcontractor)">
        <i class="fa fa-edit"></i>
        <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.subcontractors.list.table.buttons.edit-subcontractor'}]"></span>
    </button>
</ng-template>
